module.exports = __webpack_public_path__ + "img/medic.3dc37eee.jpg";